export default function PiSymbol({ size = 32, glow = true }) {
  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
      aria-label="Pi Solutions logo"
    >
      <span
        className="absolute inset-0 rounded-md"
        style={{
          background:
            "linear-gradient(135deg, rgba(57,255,20,0.18), rgba(0,191,255,0.18))",
          border: "1px solid rgba(57,255,20,0.45)",
          boxShadow: glow ? "0 0 18px rgba(57,255,20,0.35)" : "none",
        }}
      />
      <span
        className="relative font-display font-bold leading-none"
        style={{
          fontSize: size * 0.62,
          color: "#39FF14",
          textShadow: glow ? "0 0 8px rgba(57,255,20,0.8)" : "none",
        }}
      >
        π
      </span>
    </div>
  );
}
